module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rightBar"
    }
  }, [_c('div', {
    staticClass: "rightBar"
  }, [_c('div', {
    staticClass: "goldList",
    style: ('top:-' + (34 + parseInt(46 * _vm.ritNum)) + 'px')
  }, _vm._l((_vm.goldList), function(item, index) {
    return (index > _vm.goldListIndex) ? _c('li', _vm._l((item), function(item) {
      return _c('img', {
        class: 'anim' + parseInt(Math.random() * 4 + 1),
        attrs: {
          "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/doller.png"
        }
      })
    }), 0) : _vm._e()
  }), 0), _vm._v(" "), _c('audio', {
    staticClass: "glodsound",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/musics/glod.mp3",
      "id": "glodsound"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "siders",
    style: ('height:' + 46 * (_vm.ritNum - 1) + 'px')
  }, [_c('a', {
    staticClass: "userimg",
    class: 'user' + _vm.styleType,
    on: {
      "click": _vm.onToUserInfo
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.headerUrl
    }
  })]), _vm._v(" "), (_vm.isShowInvitation) ? _c('a', {
    class: 'yao' + _vm.styleType,
    on: {
      "click": _vm.onGotoInvitaion
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/yao.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowRedPack) ? _c('a', {
    class: 'shang' + _vm.styleType,
    on: {
      "click": _vm.onShangBtnClicked
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/shang.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowCall) ? _c('a', {
    class: 'tel' + _vm.styleType,
    attrs: {
      "href": _vm.iphoneNum
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/tel.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showQR) ? _c('a', {
    staticClass: "codeImg",
    class: 'code' + _vm.styleType,
    on: {
      "click": _vm.onCloseQRCode
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/code.png'
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "codeImg",
    class: 'code' + _vm.styleType,
    on: {
      "click": _vm.onTimg
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/timg.png'
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "stretch",
    class: [{
      closeside: !_vm.stretchStatus
    }, 'switch' + _vm.styleType],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stretch.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/switch.png'
    }
  })])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', [(_vm.qrCodeStr) ? _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.qrCodeStr))]) : _c('p', {
    staticClass: "title"
  }, [_vm._v("长按关注公众号")]), _vm._v(" "), _c('img', {
    staticClass: "code stop",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("关注二维码，了解更多信息")])]), _vm._v(" "), (_vm.followed) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'code-close.png'
    },
    on: {
      "click": _vm.onCloseQRCode
    }
  }) : _vm._e()]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "lazy-render": false
    },
    model: {
      value: (_vm.isShowTimg),
      callback: function($$v) {
        _vm.isShowTimg = $$v
      },
      expression: "isShowTimg"
    }
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("小程序观看直播")]), _vm._v(" "), _c('div', {
    staticClass: "code stop",
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("小程序观看直播，更快更流畅")])]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'code-close.png'
    },
    on: {
      "click": _vm.onTimg
    }
  })]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "lazy-render": false
    },
    model: {
      value: (_vm.sendredbag),
      callback: function($$v) {
        _vm.sendredbag = $$v
      },
      expression: "sendredbag"
    }
  }, [_c('rewardRedBag', {
    attrs: {
      "fans_id": _vm.fans_id
    },
    on: {
      "close": _vm.closeAction
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b88013c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/rightBar.vue
// module id = 320
// module chunks = 0